export default [
  {
    title: 'Add new',
    icon: 'mdi-plus',
    action: 'addNew',
    _enabled: false
  }
];
